import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Bio Page moved out of Settings into the Marketing workspace. This legacy path redirects straight to
 * the new location (no hop through `/bio-page`) so any existing links keep working.
 */
export const Route = createFileRoute('/_auth/$orgId/settings/link-in-bio')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/$orgId/marketing/bio-page', params: { orgId: params.orgId }, search: {}, replace: true });
  },
});
